import { render, staticRenderFns } from "./ReviewPicture.vue?vue&type=template&id=7fad1e27&scoped=true"
import script from "./ReviewPicture.vue?vue&type=script&lang=js"
export * from "./ReviewPicture.vue?vue&type=script&lang=js"
import style0 from "./ReviewPicture.vue?vue&type=style&index=0&id=7fad1e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad1e27",
  null
  
)

export default component.exports